import ExtendableError from 'es6-error';

export const SCRIPT_STEP_NOT_IMPLEMENTED = 10000;
export const SCRIPT_STEP_CANCELLED = 10001;
export const SCRIPT_STEP_MSCORE_PARSE_FAILED = 11001;

export default class EQError extends ExtendableError {
    // constructor is optional; you should omit it if you just want a custom error
    // type for inheritance and type checking
    constructor(message = 'unknown', code = -1, httpError = false) {
        super(message);
        this.message = message;
        this.code = code;
        this.httpError = httpError;
    }
}


// WEBPACK FOOTER //
// ./js/core/utils/EQError.js